import React from 'react';
import { useTranslation } from '@common/hooks/translation';
import { maskPlayerName } from '../helper';

export const PlayerConfirmation = ({ form, onClose }) => {
    const t = useTranslation();

    return (
        <>
            {onClose && (
                <i
                  onClick={onClose}
                  className="global-icon icon-Close close-popup"
                />
            )}
            <p className="popup-title">{t('player is successfully found')}</p>
            <div className="popup-main-content user-serction-container">
                <p className="text-center">
                    {t('PLEASE CONFIRM THE DETAILS BELOW ARE CORRECT BEFORE CONTINUING.')}
                </p>

                <div className="success-icon-wrapper">
                    <i className="global-icon popup-main-icon icon-success-empty" />
                </div>

                <div className="user-info-container">
                    <div className="user-info-box">
                        <p className="user-name">{maskPlayerName(form.playerName || 'no name')}</p>
                        <p className="user-id">{t('ID: ')} <span className="user-id-value">{form.playerId}</span></p>
                    </div>
                </div>
            </div>
        </>
    );
};
